/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuTypeaheadContainer_searchBrowse$ref: FragmentReference;
export type SbSharedRefineMenuTypeaheadContainer_searchBrowse = {|
  +topCategoryL1: ?VerticalType,
  +$refType: SbSharedRefineMenuTypeaheadContainer_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuTypeaheadContainer_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "topCategoryL1",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '79cac5af4db8fecce739239780194f22';
module.exports = node;
